<template>
<div>

    <div class="card animated fadeIn">
        <div class="card-header title">
            <h2 >{{ currentComercio.nombre }}</h2>
            <small>{{ showTipos(currentComercio.tipos_comercios)}}</small>

            <ul class="actions">
                <li><a href="" @click.prevent="close()"><i class="zmdi zmdi-close"></i></a></li>
            </ul>
        </div>
        
        <div class="card-body card-padding">
            <div class="view-block">
                <ul>
                    <li>
                        <i class="zmdi zmdi-pin zmdi-hc-lg"></i>
                        {{ currentComercio.domicilio_calle }} {{ currentComercio.domicilio_numero }} {{ currentComercio.domicilio_piso }}, <br/>
                        B° {{ currentComercio.nombre_barrio }}, {{ currentComercio.nombre_localidad }}
                    </li>
                    
                    <li v-if="currentComercio.celular">
                       <i class="zmdi zmdi-smartphone zmdi-hc-lg"></i>
                       {{ currentComercio.celular }}
                    </li>

                    <li v-if="currentComercio.telefonos">
                        <i class="zmdi zmdi-phone zmdi-hc-lg"></i>
                        {{ currentComercio.telefonos }}
                    </li>                                     
                </ul>
            </div>
        </div>

        <div v-if="currentComercio.tipos_canales_comunicacion.length > 0">
            <div class="card-header subtitle">
                <h2>Canales de comunicación</h2>
            </div>

            <div class="card-body card-padding">
                <div class="view-block">
                    <ul>
                        <li v-for="item in currentComercio.tipos_canales_comunicacion" :key="item.id_comercio_tipo_canal_comunicacion">
                            <i :class="getIcon(item.nombre)"></i>
                            {{ item.valor }}
                        </li>
                    </ul>
                </div>    
            </div>
        </div>

        <div v-if="currentComercio.tipos_medios_pago.length > 0">
            <div class="card-header subtitle">
                <h2>Medios de pago</h2>
            </div>

            <div class="card-body card-padding">
                <div class="view-block">
                    <ul>
                        <li v-for="item in currentComercio.tipos_medios_pago" :key="item.id_comercio_tipo_medio_pago">
                            <i :class="getIcon(item.nombre)"></i>
                            {{ item.nombre }}
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div v-if="currentComercio.dia_lunes==1 || currentComercio.dia_sabado_horario==1 || currentComercio.dia_domingo_horario==1">
            <div class="card-header subtitle">
                <h2>Días y horarios de atención</h2>
            </div>

            <div class="card-body card-padding">
                <div class="view-block">
                    <ul>
                        <li v-if="currentComercio.dia_lunes==1" class="m-b-10">
                            <i class="zmdi zmdi-time zmdi-hc-lg"></i>
                            <label>Lunes a Viernes</label><br>
                            <span v-html="showHorario(currentComercio.dia_lunes_horario)"></span>
                        </li>
                        <li v-if="currentComercio.dia_sabado==1" class="m-b-10">
                            <i class="zmdi zmdi-time zmdi-hc-lg"></i>
                            <label>Sábado</label><br>
                            <span v-html="showHorario(currentComercio.dia_sabado_horario)"></span>
                        </li>
                        <li v-if="currentComercio.dia_domingo==1" class="m-b-10">
                            <i class="zmdi zmdi-time zmdi-hc-lg"></i>
                            <label>Domingo</label><br>
                            <span v-html="showHorario(currentComercio.dia_domingo_horario)"></span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div v-if="currentComercio.takeaway==1 || currentComercio.delivery==1">
            <div class="card-header subtitle">
                <h2>Formas de entrega</h2>
            </div>

            <div class="card-body card-padding">
                <div class="view-block">
                    <ul>
                        <li v-if="currentComercio.delivery==1">
                            <i class="zmdi zmdi-bike zmdi-hc-lg"></i>
                            <label>Servicios de delivery</label><br>
                            <span v-if="currentComercio.delivery_costo_envio && currentComercio.delivery_costo_envio != ''">Cargo por envío: $ {{ currentComercio.delivery_costo_envio }}<br></span>
                            <span v-if="currentComercio.delivery_monto_minimo && currentComercio.delivery_monto_minimo != ''">Compra mínima para envío: $ {{ currentComercio.delivery_monto_minimo }}<br></span>
                            <span v-if="currentComercio.delivery_horario_envio && currentComercio.delivery_horario_envio != ''">Horario de envío: {{ currentComercio.delivery_horario_envio }}</span>
                        </li>
                        
                        <li v-if="currentComercio.takeaway==1">
                            <i class="zmdi zmdi-store zmdi-hc-lg"></i>
                            <label>Retiro de Local</label>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div v-if="currentComercio.zonas_entrega.length > 0">
            <div class="card-header subtitle">
                <h2>Zonas de entrega</h2>
            </div>

            <div class="card-body card-padding">
                <div class="view-block">
                    <ul>
                        <li>
                            <i class="zmdi zmdi-map zmdi-hc-lg"></i>
                            <span v-for="item in currentComercio.zonas_entrega" :key="item.id_comercio_zona_entrega">{{ item.nombre }}<br></span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div v-if="currentComercio.catalogo_link || currentComercio.catalogo">
            <div class="card-header subtitle">
                <h2>Catálogo / Lista de precios</h2>
            </div>

            <div class="card-body card-padding">
                <div class="view-block">
                    <ul>
                        <li v-if="currentComercio.catalogo_link && currentComercio.catalogo_link != ''">
                            <i class="zmdi zmdi-link zmdi-hc-lg"></i>
                            <label>Enlace al catálogo</label><br>
                            <a :href="currentComercio.catalogo_link" target="_blank">{{currentComercio.catalogo_link}}</a>
                        </li>

                        <li v-if="currentComercio.catalogo && currentComercio.catalogo != ''">
                            <i class="zmdi zmdi-attachment-alt zmdi-hc-lg"></i>
                            <label>Archivo Adjunto</label><br>
                            <a href="" @click.prevent="downloadFile()">{{currentComercio.catalogo}}</a> 
                        </li>
                    </ul>
                </div>    
            </div>
        </div>

    </div>        

</div>
</template>

<script>
    import { HTTPAPI, showResponseErrorMessage } from '../../share.js';
    import { mapState } from 'vuex';
    import {Jumper} from 'vue-loading-spinner';
    import axios from 'axios';

    export default {
        data() {
            return {
                isInitializing: true,
            }
        },
        computed: {
            ...mapState(['currentComercio'])
        },
        components: {
            Jumper
        },    
        mounted() {

        },
        methods: {
            getIcon(nombre){
                let icon = '';
                let nombreLowerCase = nombre.toLowerCase();

                switch (nombreLowerCase) {
                    case 'correo electrónico':
                        icon = 'email';
                        break;
                    case 'sitio web':
                        icon = 'globe';
                        break;
                    case 'app de pedidos':
                        icon = 'shopping-cart';
                        break;

                    case 'efectivo':
                        icon = 'money-box';
                        break;

                    case 'tarjeta de crédito':
                    case 'tarjeta de débito':
                        icon = 'card';
                        break;
                    
                    case 'transferencia bancaria':
                        icon = 'square-right';
                        break;

                    case 'mercado pago':
                    case 'billetera virtual':
                        icon = 'smartphone-iphone';
                        break;

                    default:
                        icon = nombre.toLowerCase()
                    break;
                }

                let classIcon = `zmdi zmdi-${icon} zmdi-hc-lg`;
                return classIcon;
            },
            goToGoogleMaps() {
                let googleMapsUrl = 'https://www.google.com.ar/maps/place';
                let address = `${this.itemLocal.domicilio_calle} ${this.itemLocal.domicilio_numero},Córdoba`
                
                address = address.replace(' ', '+');
                let url = `${googleMapsUrl}/${address}`;

                console.log('url',url);
                window.open(url, '_blank');
            },
            showDomicilio(item){
                let strDomicilio = `${item.domicilio_calle} ${item.domicilio_numero} ${item.domicilio_piso}, ${item.nombre_barrio.toUpperCase()}, ${item.nombre_localidad}`;
                return strDomicilio;
            },
            showTipos(aTipos) {
                let strTipos = aTipos.reduce( function (accumulator, item) {
                    return `${accumulator} ${item.nombre}, `;
                }, '' );

                // Quito última coma
                return strTipos.slice(0, -2);
            },
            showHorario(horario) {
                let strHorario = '';

                if (horario) {
                    let aHorario = horario.split(";");

                    let horarioDesde = aHorario[0] || '';
                    let horarioHasta = aHorario[1] || '';
                    let horarioDesde02 = aHorario[2] || '';
                    let horarioHasta02 = aHorario[3] || '';
        
                    if (horarioDesde && horarioHasta) {
                        strHorario = `${horarioDesde} a ${horarioHasta} hs`;
                    }
                    if (horarioDesde02 && horarioHasta02) {
                        strHorario += `<br>${horarioDesde02} a ${horarioHasta02} hs`;
                    }
                }

                return strHorario;
            },
            close() {
                this.$store.dispatch('getCurrentComercio', null);
            },
            downloadFile() {
                let self = this;
                let file_name = self.currentComercio.catalogo;
                
                HTTPAPI.get('comercios/' + self.currentComercio.id + '/catalogos', { responseType: 'blob' })
                .then(response => {
                    if (response.status === 200) {
                        let responseContentType = response.headers['content-type'];
                        // return false;

                        var blob = new Blob([response.data], { type: responseContentType });
                        this.downloadBlob(blob, file_name);
                    }
                }).catch(error => {
                    if (error.response) {
                        showResponseErrorMessage({ status : error.response.status });
                    } else {
                        console.log('error',error);
                    }
                });  
            },
            downloadBlob(blob, name = 'file.txt') {
                // Convert your blob into a Blob URL (a special url that points to an object in the browser's memory)
                const blobUrl = URL.createObjectURL(blob);

                // Create a link element
                const link = document.createElement("a");

                // Set link's href to point to the Blob URL
                link.href = blobUrl;
                link.download = name;

                // Append link to the body
                document.body.appendChild(link);

                // Dispatch click event on the link
                // This is necessary as link.click() does not work on the latest firefox
                link.dispatchEvent(
                    new MouseEvent('click', { 
                    bubbles: true, 
                    cancelable: true, 
                    view: window 
                    })
                );

                // Remove link from body
                document.body.removeChild(link);
            },
        }
    }
</script>

<style lang="scss" scoped>

    .card-body {
        border-bottom: 1px solid #e6e6e6;
        padding: 10px 26px 10px 26px !important;
    }

    .title {
        padding-bottom: 0px !important;

        h2 {
            color:#a4343a !important;
        }
    }
    
    .subtitle {
        padding-bottom: 5px !important;
    }
    .view-block {
        padding: 0px;
        
        ul {
            padding-left: 0px;
            list-style: none;
        }

        li {
            position: relative;
            margin-bottom: 0px !important;
            padding: 8px 0 8px 25px;

            i {
                color: rgb(164,52,58);
                vertical-align: top;
                line-height: 100%;
                position: absolute;
                left: 0;

            }
        }
    }
</style>